import { useEffect, useState } from "react";
import { BUILD_ID } from "../lib/env";

// Si se despliega una versión nueva mientras una pestaña sigue abierta con un bundle
// antiguo, el index.html servido referencia un hash distinto al cargado. Se comprueba
// cada 5 min y al volver a la pestaña, y se ofrece recargar. Sin efecto en dev-server
// (no hay hash de bundle) ni cuando no hay despliegue nuevo.
export default function VersionGuard() {
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    if (BUILD_ID === "dev") return undefined;
    let cancelled = false;
    const check = async () => {
      try {
        const res = await fetch("/", { cache: "no-store", credentials: "same-origin" });
        const html = await res.text();
        const match = html.match(/main\.([a-f0-9]+)\.js/);
        if (!cancelled && match && match[1] !== BUILD_ID) setOutdated(true);
      } catch {
        // sin conectividad: no hacer nada
      }
    };
    const interval = setInterval(check, 5 * 60 * 1000);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  if (!outdated) return null;
  return (
    <div
      data-testid="app-update-banner"
      className="fixed bottom-0 inset-x-0 z-[210] bg-zinc-900 text-white text-sm text-center py-2.5 px-4"
    >
      Hay una nueva versión de Asset Passport disponible.
      <button
        onClick={() => window.location.reload()}
        data-testid="app-update-reload"
        className="underline underline-offset-2 font-medium ml-2 hover:text-zinc-300 transition-colors"
      >
        Actualizar ahora
      </button>
    </div>
  );
}
